export const unauthenticatedPaths = {
  login: '/login',
  register: '/signup',
  resetPassword: '/reset-password',
  resetPasswordSubmit: '/reset-password-submit',
  newPasswordRequired: '/new-password-required',
  confirmUser: '/confirm-user',
} as const

export const authenticatedPaths = {
  supportPlans: '/support-plans',
  profileSettings: '/profile-settings',
  agencyId: '/:agencyId',
  account: '/account',
  billing: '/billing',
  support: '/support',
  brandPath: '/:brandPath',
  workspaceSettings: '/workspace-settings',
  workspaceFeeds: '/workspace-feeds',
  workspaceFeedsNew: '/workspace-feeds/new-feed',
  workspaceHome: '/',
  workspaceAiRules: '/workspace-ai-rules',
  workspaceAnalytics: '/analytics',
  newPublication: '/new-publication',
  newSystem: '/new-system',
  newWorkspace: '/new-workspace',
  siteHome: '/',
  siteCollections: '/collections',
  siteCollectionsNew: '/collections/new',
  siteAssets: '/assets',
  siteAnalytics: '/analytics',
  siteArticles: '/stories',
  siteWriters: '/writers',
  siteSections: '/sections',
  siteSpotlight: '/spotlight',
  siteTags: '/tags',
  siteFrontPage: '/front-page',
  // Public newsletter signup PAGE editor (under the Pages submenu). Renamed off
  // '/newsletters' so the consolidated newsletter hub can own that route; the
  // underlying public page slug ('/newsletters/') is unchanged.
  siteNewsletters: '/newsletter-signup',
  siteTermsAndConditions: '/terms-and-conditions',
  sitePrivacyPolicy: '/privacy-policy',
  siteFAQ: '/faq',
  siteAccountPageEdit: '/account-page',
  siteThankYou: '/thank-you',
  siteSearch: '/search',
  siteEvents: '/events',
  siteGift: '/gift',
  siteContactUs: '/contact-us',
  siteSubscribe: '/subscribe',
  siteMenus: '/menus',
  siteTemplate: '/template',
  siteChats: '/chats',
  siteReports: '/reports',
  siteSettingsGeneral: '/settings/general',
  siteSettingsAP: '/settings/associated-press',
  siteSettingsReuters: '/settings/reuters',
  siteSettingsFeeds: '/settings/feeds',
  siteSettingsExternalFeeds: '/settings/external-feeds',
  siteSettingsExternalFeedsNew: '/settings/external-feeds/new-external-feed',
  siteSettingsChatbotPublication: '/settings/chatbot-publication',
  siteSettingsChatbotCMS: '/settings/chatbot-cms',
  siteSettingsWeather: '/settings/weather-api',
  siteSettingsPricing: '/settings/subscription-plans',
  siteSettingsPricingConnectStripeAccountRefresh: '/settings/subscription-plans/connect-stripe-account-refresh',
  siteSettingsPricingNew: '/settings/subscription-plans/new',
  siteSettingsGiftNew: '/settings/subscription-plans/gifts/new',
  siteSettingsGiftEdit: '/settings/subscription-plans/gifts/',
  siteSettingsPromotionNew: '/settings/subscription-plans/promotions/new',
  siteSettingsPromotionEdit: '/settings/subscription-plans/promotions/',
  siteSettingsArticleGeneration: '/settings/story-generation',
  siteSettingsUsers: '/settings/users',
  siteSettingsUserNew: '/settings/users/new',
  siteSettingsUserEdit: '/settings/users/:userId',
  siteSettingsThirdPartyAnalytics: '/settings/third-party-analytics',
  siteSettingsAdvertisement: '/settings/advertisement',
  siteSettingsFotomoto: '/settings/fotomoto',
  siteSettingsGelato: '/settings/gelato',
  // Consolidated newsletter hub (Mailchimp + custom/PubGen). Lives at
  // '/newsletters'. Key names keep the legacy `siteNewsletterSystem*` prefix to
  // avoid churn across the ~12 consumer files; only the route values moved.
  siteNewsletterSystem: '/newsletters',
  siteNewsletterSystemDisplay: '/newsletters/display',
  siteNewsletterSystemSettings: '/newsletters/settings',
  siteNewsletterSystemNew: '/newsletters/new',
  siteNewsletterSystemEdit: '/newsletters/:newsletterId',
  siteNewsletterSystemContacts: '/newsletters/contacts',
  siteNewsletterSystemContactNew: '/newsletters/contacts/new',
  siteNewsletterSystemSegments: '/newsletters/segments',
  siteNewsletterSystemSegmentNew: '/newsletters/segments/new',
  siteNewsletterSystemSegmentEdit: '/newsletters/segments/:segmentId',
  siteNewsletterSystemSends: '/newsletters/sends',
  siteNewsletterSystemAutomations: '/newsletters/automations',
  siteNewsletterSystemAutomationNew: '/newsletters/automations/new',
  siteNewsletterSystemAutomationEdit: '/newsletters/automations/:automationId',
  // Legacy Mailchimp newsletter create/edit, migrated out of `/settings/newsletters`
  // into the hub. Namespaced under `/newsletters/mailchimp/*` to avoid colliding
  // with the custom create/edit routes at `/newsletters/new` and `/newsletters/:id`.
  siteNewslettersMailchimpNew: '/newsletters/mailchimp/new',
  siteNewslettersMailchimpEdit: '/newsletters/mailchimp/:newsletterId',
  siteSettingsStyles: '/settings/styles',
  siteSettingsCustomDomain: '/settings/domain',
  siteSettingsRedirects: '/settings/redirects',
  siteSettingsMobileApp: '/settings/mobile-app',
  siteSettingsDataImports: '/settings/data-imports',
  siteSettingsDataExports: '/settings/data-exports',
  siteSettingsSetupStatus: '/settings/setup-status',
} as const
